import { ConfigApi } from '@backstage/core-plugin-api';

// An ArgoCD instance from `argocd.appLocatorMethods[].instances` (name + url
// are frontend-visible in the Roadie plugin's config schema).
export interface ArgoInstance {
  name: string;
  url: string;
  frontendUrl?: string;
}

export function readArgoInstances(config: ConfigApi): ArgoInstance[] {
  return (config.getOptionalConfigArray('argocd.appLocatorMethods') ?? []).flatMap(m =>
    (m.getOptionalConfigArray('instances') ?? []).map(i => ({
      name: i.getString('name'),
      url: i.getString('url'),
      frontendUrl: i.getOptionalString('frontendUrl'),
    })),
  );
}

const hostOf = (url: string): string | undefined => {
  try {
    return new URL(url).host.toLowerCase();
  } catch {
    return undefined;
  }
};

// The configured instance that serves this ArgoCD UI link (matched by host),
// or undefined when Launchpad has no API access to that ArgoCD.
export function argoInstanceForUrl(
  instances: ArgoInstance[],
  argocdUrl: string,
): ArgoInstance | undefined {
  const host = hostOf(argocdUrl);
  if (!host) return undefined;
  return instances.find(i => hostOf(i.url) === host || (i.frontendUrl && hostOf(i.frontendUrl) === host));
}
